import { Form } from 'react-bootstrap'
import { getPerformanceLabels, PerformanceGranularity } from '../../../report-performance'
import { ReportSectionId, ReportUserKind } from '../../../report-sections'

type AdditionalReportPagesProps = {
    idPrefix: string
    granularity: PerformanceGranularity
    userKind: ReportUserKind
    value: ReportSectionId[]
    onChange: (sections: ReportSectionId[]) => void
}

export default function AdditionalReportPages(opts: AdditionalReportPagesProps) {
    const labels = getPerformanceLabels(opts.granularity)

    const toggleSection = (section: ReportSectionId, checked: boolean) => {
        opts.onChange(checked
            ? Array.from(new Set([...opts.value, section]))
            : opts.value.filter((item) => item !== section)
        )
    }

    const section = (
        id: ReportSectionId,
        label: string,
        description: string,
    ) => (
        <div className="mb-2" key={id}>
            <Form.Check
                type="checkbox"
                id={`${opts.idPrefix}-${id.replace('.', '-')}`}
                label={label}
                checked={opts.value.includes(id)}
                onChange={(event) => toggleSection(id, event.target.checked)}
            />
            <Form.Text className="text-muted d-block ms-4">{description}</Form.Text>
        </div>
    )

    return (
        <Form.Group className="mt-2">
            <Form.Label>Additional report pages</Form.Label>
            <div className="border rounded p-3">
                <div className="fw-semibold mb-2">Trend &amp; comparison</div>
                {section(
                    'performance.overview',
                    labels.overview,
                    'Shows the latest 12 completed reporting periods.',
                )}
                {section(
                    'performance.keyMetrics',
                    labels.keyMetrics,
                    'Compares the two latest completed reporting periods.',
                )}

                <div className="fw-semibold mt-3 pt-3 mb-2 border-top">Analyses</div>
                {opts.userKind === 'advertiser' && section(
                    'analysis.publisher',
                    'Publisher analysis',
                    'Adds publisher activity and revenue changes. Awin-only report data can also include publisher type, device, click-to-sale and product insights.',
                )}
                {section(
                    'analysis.campaign',
                    'Campaign analysis',
                    `Adds campaigns with clicks, campaigns with sales, clicks without sales and ${opts.userKind === 'publisher' ? 'commission' : 'revenue'} changes.`,
                )}
            </div>
        </Form.Group>
    )
}
